import { Grid, styled, Typography } from '@mui/material'

import { convertToComponent } from '@ecm/data/Contentful'
import { Testimonial } from '@ecm/data/Testimonial'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'

export type TestimonialCarouselProps = {
  className?: string
  testimonials: Testimonial[]
}

export const TestimonialCarousel = styled(
  ({ className, testimonials }: TestimonialCarouselProps) => {
    const testimonial = testimonials[0]

    return (
      <Grid
        className={className}
        container
        direction="column"
        alignItems="center"
        padding="2em"
        margin="2em 0"
        bgcolor={Color.smoke.normal}
        width="100%"
      >
        <CloudflareImage src={`/images/icon/integrations.svg`} width="72" height="72" />

        <MainContainer>{convertToComponent(testimonial.quote)}</MainContainer>

        <Grid
          container
          direction="column"
          justifyContent="space-around"
          alignItems="center"
          margin="1em 0"
        >
          <Typography variant="p3" fontWeight={700} margin="0">
            {testimonial.fullName}
          </Typography>
          <Typography variant="p3" margin="0">
            {testimonial.description}
          </Typography>
        </Grid>
      </Grid>
    )
  }
)({ p: { textAlign: 'center' } })

export default TestimonialCarousel
